import React from 'react';
import PropTypes from 'prop-types';
import style from './styles.scss';

import { flatMap, unionBy, uniqBy } from '../../../../util/lodashlike';
const FinalSegmentForExecuted = ({ typologySets, typologiesList }) => {
  const flatSets = flatMap(
    typologiesList,
    (typologyWrapper) => typologyWrapper.combinations
  );
  const allSets = uniqBy(flatSets, 'id');
  return (
    <div className={style.selectedSetsPanel}>
      <div className={style.setsPanelText}>
        <p>
          Final Segment to typology mapping (Based on the configurations made)
        </p>
      </div>
      {allSets?.map((combinations) => {
        if (
          typologySets.some((t) =>
            t.segmentCombinationIds.includes(combinations.id)
          )
        ) {
          return (
            <table className={style.displayTable} key={combinations.id}>
              <thead>
                <tr className={style.rowDisplay}>
                  <th className={style.tableHeader}>{combinations.title}</th>
                  <th className={style.tableHeader}>Action</th>
                </tr>
              </thead>
              <tbody>
                {typologySets?.map((typology) => {
                  if (
                    typology.segmentCombinationIds.includes(combinations.id)
                  ) {
                    return (
                      <tr
                        className={style.rowDisplay}
                        key={typology.typologyId}>
                        <td className={style.tableData}>
                          {typology.typologyName}
                        </td>
                        <td
                          className={style.tableData}
                          key={typology.typologyId}
                          style={{ padding: 0 }}>
                          <button
                            style={{ color: '#0C8ED7', cursor: 'no-drop' }}>
                            {' '}
                            Remove
                          </button>
                        </td>
                      </tr>
                    );
                  }
                  return null;
                })}
              </tbody>
            </table>
          );
        }
      })}
      {typologySets.some((t) => t.useDefault) && (
        <table className={style.displayTable}>
          <thead>
            <tr className={style.rowDisplay}>
              <th className={style.tableHeader}>{`Default`}</th>
              <th className={style.tableHeader}>Action</th>
            </tr>
          </thead>
          <tbody>
            {typologySets?.map((typology) => {
              if (typology.useDefault) {
                return (
                  <tr className={style.rowDisplay} key={typology.typologyId}>
                    <td className={style.tableData}>{typology.typologyName}</td>
                    <td
                      className={style.tableData}
                      key={typology.typologyId}
                      style={{ padding: 0 }}>
                      <button style={{ color: '#0C8ED7', cursor: 'no-drop' }}>
                        {' '}
                        Remove
                      </button>
                    </td>
                  </tr>
                );
              }
              return null;
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

FinalSegmentForExecuted.propTypes = {
  typologySets: PropTypes.array,
  typologiesList: PropTypes.object
};

export default FinalSegmentForExecuted;
